export const FEATURE_NAME = '@zerops/zerops/feature/sync-dialog';
